// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3AGU1","insightsList":"newBusinessInsightsMenu_insightsList__2ntFg","active":"newBusinessInsightsMenu_active__38rBK"};